import React, { useState } from 'react';
import { History } from 'history';
import { TFunction } from 'react-i18next';
import {
  OverlayView,
  View,
  Card,
  Stack,
  Button,
  Information,
  Header,
  Text,
  FilePicker,
  withTranslation,
  Tooltip,
  Layout,
} from '@piwikpro/ui-components';
import { UnsavedChangesTracker as UnsavedChangesTrackerComponent } from '@piwikpro/form-crate/components/UnsavedChangesTracker';
import { withInject, errorBoundary } from '@piwikpro/platform';
import { LogoAndFaviconPreview } from '../LogoAndFaviconPreview';
import { Organization } from '../../Organization';

const DEFAULT_PP_FAVICON = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAA8FBMVEUbGhodHBweHR0fHh4gHh4gHx8hICAiISEjIiIlJCQnJiYxMDA1NDQ1NTU4Nzc6OTk7Ojo9PDxAPz9BQEBKSUlRUFBbW1tdXFxfXl5iYWFjY2NkY2NkZGRlZWVoZ2dpaGhqaWlqamprampra2tsbGxwb292dXV3d3d6enp7enqCgYGMi4uMjIyNjIyOjo6VlJSampqfnp6ioaGioqKjoqKko6Oqqamrqqqurq7Ew8PExMTGxcXHx8fPz8/b2tre3t7f3t7h4eHk5OTo6Ojp6enu7u7w8PDz8/P29vb39/f4+Pj7+/v8/Pz9/f3+/v7////sradRAAAAzklEQVQ4y+XTV1cCMRCG4d0M2bDSUYoiRZQiSluwUlaxAQl8///fcKF4NQv38F4/5+QkM7HUnqxDA/Ivcnjg1oae53mDfj0mOUDn3/jNTC4dDtzhv488MaANrMePT89TAK8RhwXmWih1OgKWFxQM7BaAW8ECfWU70u4AaPDANKPxxI0PfGX4I9af/tv7HMCDy99i20taBgCjtV743VRI8WDVK5ZKuaTin7oN6LIlBEl+mnQPmKoIHjcVfjA7kzv24aTSyYZ3LgwRHcO/4NsACKY84W5ApysAAAAASUVORK5CYII=';
const DEFAULT_PP_LOGO = 'data:image/png;base64,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';
const MIN_LOGO_HEIGHT_PX = 16;
const MAX_LOGO_FILE_SIZE_BYTES = 200000; // 200kB
const MIN_FAVICON_WIDTH_HEIGHT_PX = 16;
const MAX_FAVICON_FILE_SIZE_BYTES = 50000; // 50kB
// to allow upload too big file and validate size further, with proper information for user
const MAX_FILE_SIZE_FOR_UPLOAD = 100000000000000; // 1GB
const LOGO_EXTENSIONS = ['image/png', 'image/jpeg'];
const FAVICON_EXTENSIONS = ['image/png', 'image/jpeg'];

interface LogoAndFaviconEditProps {
  history: History
  Title: React.ElementType
  userLang: string
  i18n: any
  organizationApi: Organization
  t: TFunction
  UnsavedChangesTracker: typeof UnsavedChangesTrackerComponent
}

interface FileDetails {
  text: string
  additionalInfo: string
  preview: {
    type: 'image'
    data: string
  }
  rawFile: File
}

class ValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
  }
}

const toBase64 = (file: File) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
});

interface LogoAndFaviconState {
  logo: {
    details: null | FileDetails
    error: null | string
  }
  favicon: {
    details: null | FileDetails
    error: null | string
  }
}

const initialState = {
  logo: {
    details: null,
    error: null,
  },
  favicon: {
    details: null,
    error: null,
  },
};

const asImage = (base64data: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img = new Image();

    // for testing purpose
    if ((img as any).setAttributeForTests) {
      (img as any).setAttributeForTests();
    }

    img.src = base64data;
    img.addEventListener('load', () => {
      resolve(img);
    });
    img.onerror = reject;
  });

const validateImage = (image: HTMLImageElement, size: number, type: 'logo' | 'favicon') => {
  if (type === 'logo') {
    if (image.height < MIN_LOGO_HEIGHT_PX) {
      throw new ValidationError('accountSettings.logoAndFavicon.upload.validation.logo.height-too-low');
    }

    if (size > MAX_LOGO_FILE_SIZE_BYTES) {
      throw new ValidationError('accountSettings.logoAndFavicon.upload.validation.logo.file-size-too-big');
    }
  }

  if (type === 'favicon') {
    if (image.height < MIN_FAVICON_WIDTH_HEIGHT_PX || image.width < MIN_FAVICON_WIDTH_HEIGHT_PX) {
      throw new ValidationError('accountSettings.logoAndFavicon.upload.validation.favicon.dimensions-too-low');
    }

    if (size > MAX_FAVICON_FILE_SIZE_BYTES) {
      throw new ValidationError('accountSettings.logoAndFavicon.upload.validation.favicon.file-size-too-big');
    }
  }
};

const LogoAndFaviconEdit = ({
  history,
  Title,
  i18n,
  userLang,
  organizationApi,
  t,
  UnsavedChangesTracker,
}: LogoAndFaviconEditProps) => {
  const [logoFaviconData, setLogoFaviconData] = useState<LogoAndFaviconState>(initialState);

  const handleClose = () => {
    history.push(history.location.pathname.split('/o/')[0]);
  };

  const getSubmitButton = (onClose) => {
    const isFormValid = logoFaviconData.logo.details !== null
    && logoFaviconData.favicon.details !== null;

    const SubmitButton = () => (
      <Button
        disabled={!isFormValid}
        text={t('accountSettings.logoAndFavicon.edit.form.save.button.text')}
        appearance="primary"
        onClick={async () => {
          try {
            await organizationApi.sendBrandingImages({
              logo: logoFaviconData.logo.details!.rawFile,
              favicon: logoFaviconData.favicon.details!.rawFile,
            });

            setLogoFaviconData(initialState);
            onClose();

            // refetch index.html to apply changes
            setTimeout(() => {
              window.location.reload();
            }, 1000);
            // eslint-disable-next-line no-empty
          } catch { }
        }}
      />
    );

    if (isFormValid) {
      return <SubmitButton />;
    }

    return (
      <Tooltip content={t('accountSettings.logoAndFavicon.edit.form.save.button.tooltip')}>
        <SubmitButton />
      </Tooltip>
    );
  };

  const handleFileUpload = async (acceptedFiles: File[], type: 'logo' | 'favicon') => {
    const file = acceptedFiles[0];
    let imgAsBase64;

    try {
      if (acceptedFiles.length === 0) {
        throw new ValidationError(
          type === 'logo' ? 'accountSettings.logoAndFavicon.upload.validation.logo.not-accepted-ext'
            : 'accountSettings.logoAndFavicon.upload.validation.favicon.not-accepted-ext',
        );
      }


      imgAsBase64 = await toBase64(file);

      const image = await asImage(imgAsBase64 as string);

      validateImage(image, file.size, type);
    } catch (err: any) {
      let errorMessage = 'accountSettings.logoAndFavicon.upload.validation.decodeError';

      if (err.name === 'ValidationError') {
        errorMessage = err.message;
      }

      setLogoFaviconData({
        ...logoFaviconData,
        [type]: {
          details: null,
          error: t(errorMessage),
        },
      });

      return;
    }

    const fileSizeFormattedTokB = `${i18n.format(
      Number(file.size / 1000),
      () => { },
      userLang,
    )}kB`;

    const fileDetails: FileDetails = {
      text: file.name,
      additionalInfo: fileSizeFormattedTokB,
      preview: {
        type: 'image',
        data: imgAsBase64,
      },
      rawFile: file,
    };

    setLogoFaviconData({
      ...logoFaviconData,
      [type]: {
        details: fileDetails,
      },
    });
  };

  const isModified = logoFaviconData.logo.details || logoFaviconData.favicon.details;

  return (
    <Title part={t('accountSettings.logoAndFavicon.edit.title')} subset>
      <UnsavedChangesTracker
        discardAction={handleClose}
        type="twoOptions"
        isModified={!!isModified}
        render={(api) => {
          const { UnsavedChangesModal } = api;
          return (
            <OverlayView
              isOpen
              onClose={api.onClose}
              title={t('accountSettings.logoAndFavicon.edit.title')}
            >
              <div style={{ height: '100%', marginTop: '8px' }}>
                <View heightAuto>
                  <View.Body>
                    <Layout maxWidth="medium">
                      <Stack vertical>
                        <Stack.Item />
                        <Stack.Item fill>
                          <Information type="info">
                            {t('accountSettings.logoAndFavicon.edit.update.info')}
                          </Information>
                        </Stack.Item>
                        <Stack.Item fill>
                          <Card>
                            <Card.Section>
                              <Stack dataId="LogoUploadSection" vertical>
                                <Stack.Item>
                                  <Header type="small">
                                    {t('accountSettings.logoAndFavicon.edit.logo.title')}
                                  </Header>
                                </Stack.Item>
                                <Stack.Item previousSpacing="narrow">
                                  <Text>
                                    {t('accountSettings.logoAndFavicon.edit.logo.description')}
                                  </Text>
                                </Stack.Item>
                                <Stack.Item fill>
                                  <FilePicker
                                    type="horizontal"
                                    fileDetails={logoFaviconData.logo.details}
                                    accept={LOGO_EXTENSIONS}
                                    maxFileSize={MAX_FILE_SIZE_FOR_UPLOAD}
                                    onDrop={acceptedFiles => handleFileUpload(acceptedFiles, 'logo')}
                                    onCancelOrRemoveClick={() => setLogoFaviconData({
                                      ...logoFaviconData,
                                      logo: {
                                        details: null,
                                        error: null,
                                      },
                                    })}
                                    error={logoFaviconData.logo.error}
                                  />
                                </Stack.Item>
                              </Stack>
                            </Card.Section>
                            <Card.Section>
                              <Stack dataId="FaviconUploadSection" vertical>
                                <Stack.Item>
                                  <Header type="small">
                                    {t('accountSettings.logoAndFavicon.edit.favicon.title')}
                                  </Header>
                                </Stack.Item>
                                <Stack.Item previousSpacing="narrow">
                                  <Text>
                                    {t('accountSettings.logoAndFavicon.edit.favicon.description')}
                                  </Text>
                                </Stack.Item>
                                <Stack.Item fill>
                                  <FilePicker
                                    type="horizontal"
                                    fileDetails={logoFaviconData.favicon.details}
                                    accept={FAVICON_EXTENSIONS}
                                    maxFileSize={MAX_FILE_SIZE_FOR_UPLOAD}
                                    onDrop={acceptedFiles => handleFileUpload(acceptedFiles, 'favicon')}
                                    onCancelOrRemoveClick={() => setLogoFaviconData({
                                      ...logoFaviconData,
                                      favicon: {
                                        details: null,
                                        error: null,
                                      },
                                    })}
                                    error={logoFaviconData.favicon.error}
                                  />
                                </Stack.Item>
                              </Stack>
                            </Card.Section>
                            <Card.Section subdued>
                              <Stack vertical horizontalAlignment="middle" verticalAlignment="center">
                                <Stack.Item fill>
                                  <Header type="small">
                                    {t('accountSettings.logoAndFavicon.edit.preview.title')}
                                  </Header>
                                </Stack.Item>
                                <Stack.Item>
                                  <LogoAndFaviconPreview
                                    moduleName={t('moduleName')}
                                    logo={
                                      logoFaviconData.logo.details?.preview.data
                                    || DEFAULT_PP_LOGO
                                    }
                                    favicon={
                                      logoFaviconData.favicon.details?.preview.data
                                    || DEFAULT_PP_FAVICON
                                    }
                                  />
                                </Stack.Item>
                              </Stack>
                            </Card.Section>
                          </Card>
                        </Stack.Item>
                      </Stack>
                    </Layout>
                  </View.Body>
                  <View.Action isFloating>
                    <Stack horizontalAlignment="right" fullWidth spacing="narrow">
                      <Stack.Item>
                        <Button
                          text={t('accountSettings.logoAndFavicon.edit.form.cancel.button.text')}
                          onClick={api.onClose}
                        />
                      </Stack.Item>
                      <Stack.Item>
                        {getSubmitButton(api.onClose)}
                        <UnsavedChangesModal />
                      </Stack.Item>
                    </Stack>
                  </View.Action>
                </View>
              </div>
            </OverlayView>
          );
        }}
      />
    </Title>
  );
};

export default withInject({
  organizationApi: 'OrganizationCrate.organization',
  history: 'RouterCrate.history',
  Title: 'TitleCrate.components.Title',
  i18n: 'TranslationCrate.i18n',
  UnsavedChangesTracker: 'FormCrate.components.UnsavedChangesTracker',
})(withTranslation(['administration'])(errorBoundary(LogoAndFaviconEdit)));
